import Product from './product'

export default class Category {
  constructor({ name, description, id, slug }) {
    this.description = description;
    this.id = id;
    this.name = name;
    this._productsCount = 0;
    this._products = [];
    this.slug = slug;
  }

  get products() { return this._products; }
  get productsCount() { return this._productsCount; }

  set products(products) {
    this._products = products.map(p => new Product(Product.format(p)));
    this._productsCount = this._products.length;
  }

  static format(category) {
    return {
      description: category.descr,
      id: category.id,
      name: category.title,
      slug: category.slug,
    };
  }
} 